import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import EdiRfidAuditRequestExecutionListColumns from '../../containers/EdiRfidAuditRequestExecutionListColumns';

export const getIsLoading = (state) => state.listing.EDI_RFID_AUDIT_REQUEST_EXECUTIONS.isLoading;
export const getCheckedRows = (state) => state.listing.EDI_RFID_AUDIT_REQUEST_EXECUTIONS.selectedRows;
export const getData = TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTIONS.getDataFunction();
export const getColumns = createSelector(
  getData,
  EdiRfidAuditRequestExecutionListColumns,
);
